import { render } from "./SliderCaptcha.vue?vue&type=template&id=1140e164&scoped=true"
import script from "./SliderCaptcha.vue?vue&type=script&lang=js"
export * from "./SliderCaptcha.vue?vue&type=script&lang=js"

import "./SliderCaptcha.vue?vue&type=style&index=0&id=1140e164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1140e164"]])

export default __exports__